import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
// 引入 VConsole   调试工具    *正式上线时需要注释掉*
// import VConsole from 'vconsole';
// new VConsole();

Vue.use(Vant);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')